"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercetoolsAuthApi = void 0;
var types_1 = require("./types");
var __1 = require("../");
var scopes_1 = require("./scopes");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var axios_1 = __importDefault(require("axios"));
var constants_2 = require("../constants");
var utils_2 = require("../utils");
/**
 * Provides an easy to use set of methods for communicating with the commercetools
 * HTTP Authorization API
 */
var CommercetoolsAuthApi = /** @class */ (function () {
    function CommercetoolsAuthApi(config) {
        this.config = config;
        this.endpoints = constants_1.REGION_URLS[this.config.region];
        this.userAgent = utils_2.buildUserAgent(this.config.systemIdentifier);
    }
    /**
     * Get a new client grant:
     * https://docs.commercetools.com/api/authorization#client-credentials-flow
     */
    CommercetoolsAuthApi.prototype.getClientGrant = function (scopes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post('/token', {
                        grant_type: types_1.GrantType.CLIENT_CREDENTIALS,
                        scope: scopes_1.scopeArrayToRequestString(scopes, this.config.projectKey)
                    })];
            });
        });
    };
    /**
     * Refresh a customer or client grant given a refresh token:
     * https://docs.commercetools.com/api/authorization#refresh-token-flow
     */
    CommercetoolsAuthApi.prototype.refreshGrant = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('/token', {
                            grant_type: types_1.GrantType.REFRESH_TOKEN,
                            refresh_token: refreshToken
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Login the customer using the given options:
     * https://docs.commercetools.com/api/authorization#password-flow
     */
    CommercetoolsAuthApi.prototype.login = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post("/" + this.config.projectKey + this.applyStore('/customers/token', options.storeKey), {
                        username: options.username,
                        password: options.password,
                        grant_type: types_1.GrantType.PASSWORD,
                        scope: scopes_1.scopeArrayToRequestString(options.scopes, this.config.projectKey)
                    })];
            });
        });
    };
    /**
     * Get a grant an anonymous customer:
     * https://docs.commercetools.com/api/authorization#tokens-for-anonymous-sessions
     */
    CommercetoolsAuthApi.prototype.getAnonymousGrant = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var postOptions;
            return __generator(this, function (_b) {
                postOptions = {
                    grant_type: types_1.GrantType.CLIENT_CREDENTIALS
                };
                if ((_a = options === null || options === void 0 ? void 0 : options.scopes) === null || _a === void 0 ? void 0 : _a.length) {
                    postOptions.scope = scopes_1.scopeArrayToRequestString(options.scopes, this.config.projectKey);
                }
                if (options === null || options === void 0 ? void 0 : options.anonymousId) {
                    postOptions.anonymous_id = options.anonymousId;
                }
                return [2 /*return*/, this.post("/" + this.config.projectKey + "/anonymous/token", postOptions)];
            });
        });
    };
    /**
     * Construct and send a request to the commercetools auth endpoint.
     */
    CommercetoolsAuthApi.prototype.post = function (path, body) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var options, headers, response, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        options = {
                            url: this.endpoints.auth + "/oauth" + path,
                            method: 'POST',
                            data: new URLSearchParams(body).toString()
                        };
                        headers = {
                            Authorization: "Basic " + utils_1.base64EncodeForBasicAuth(this.config.clientId, this.config.clientSecret),
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                        if ((_a = process === null || process === void 0 ? void 0 : process.release) === null || _a === void 0 ? void 0 : _a.name) {
                            headers['User-Agent'] = this.userAgent;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default(__assign(__assign({}, options), { headers: headers, timeout: this.config.timeoutMs || constants_2.DEFAULT_REQUEST_TIMEOUT_MS }))];
                    case 2:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1.isAxiosError) {
                            throw __1.CommercetoolsError.fromAxiosError(error_1);
                        }
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Applies the store key to a given path
     */
    CommercetoolsAuthApi.prototype.applyStore = function (path, storeKey) {
        if (typeof storeKey === 'string' && storeKey !== '') {
            return "/in-store/key=" + storeKey + path;
        }
        else if (this.config.storeKey) {
            return "/in-store/key=" + this.config.storeKey + path;
        }
        return path;
    };
    return CommercetoolsAuthApi;
}());
exports.CommercetoolsAuthApi = CommercetoolsAuthApi;
//# sourceMappingURL=CommercetoolsAuthApi.js.map